export enum Permissions {
  // EI Permissions
  CanViewEIRecords = 1,
  CanAddEIRecords = 2,
  RequestAdditionalDocs = 3,
  //Schedule Gen
  CanScheduleGEN = 37,
  CanRescheduleGEN = 288,
  //Schedule SHM
  CanScheduleSHM = 35,
  CanReScheduleSHM = 36,
  // Referrals - Initial
  CanAddReferralRecords = 5,
  CanViewInitialReferral = 4,
  CanEditInitialReferral = 6,
  CanViewRequestForInitialReferral = 7,
  CanEditRequestForInitialReferral = 8,
  CanReviewReferrals = 28,
  // Request for Reeval
  CanCreateRequestforReevaluation = 314,
  CanEditRequestforReevaluation = 315,
  CanReviewRequestforReevaluation = 316,
  CanViewRequestforReevaluation = 317,
  CanCreateRequestforAdditionalReevaluation = 318,
  CanEditRequestforAdditionalReevaluation = 319,
  CanReviewRequestforAdditionalReevaluation = 320,
  CanViewRequestforAdditionalReevaluation = 321,

  CanViewEvaluationRecords = 12,
  CanViewPlacementRecords = 13,
  CanViewIEPRecords = 14,
  CanViewCBSTRecords = 15,
  CanSendPWN = 32,
  CanEditPWN = 34,
  CanViewPWN = 33,
  CanSendReevalPWN = 29,
  CanViewReevalPWN = 30,
  CanEditReevalPWN = 31,

  // Student Profile
  CanViewStudentProfile = 9,
  CanEditStudentProfile = 10,
  CanCreateStudent = 260,

  //Evalution
  CanEditEvaluationsRecords = 16,
  CanAddEvaluationsRecords = 17,
  CanCompleteEvaluationsRecords = 18,
  CanReviewEvaluationsRecords = 231,

  //Placements
  CanAddPlacementsRecords = 19,
  CanEditPlacementsRecords = 20,
  CanCompletePlacementsRecords = 21,

  //IEP
  CanAddIEPRecords = 22,
  CanEditIEPRecords = 23,
  CanCompleteIEPRecords = 24,


  //CBST
  CanAddCBSTRecords = 25,
  CanEditCBSTRecords = 26,
  CanCompleteCBSTRecords = 27,


  //Schedule IEP
  CanScheduleIEPMeeting = 66,
  CanRescheduleIEPMeeting = 67,

  //Declassification
  CanCreateDeclassification = 71,
  CanEditDeclassification = 72,

  // Ineligibility
  CanCreateIneligibilityDocument = 75,

  //Assurance Checklist
  CanEditAssuranceChecklist = 83,

  //lre
  CanEditLREForm = 80,
  CanCreateLREForm = 82,

  //Waiver
  CanCreateWaiverofIEPMeeting = 73,

  CanCreatePreSchoolSummary = 44,
  CanEditCPreSchoolSummary = 45,
  CanInitiateAssessmentPlanning = 42,

  CanCreate12MonthSchoolYearConsentForm = 68,
  CanEdit12MonthSchoolYearConsentForm = 69,

  CanCreateNoticeofTermination = 96,
  CanEditNoticeofTermination = 97,

  CanCreateConsentforInitialProvisionofServices = 87,
  CanEditConsentforInitialProvisionofServices = 94,

  CanCreatePriorNoticeforPlacementWithdrawal = 89,
  CanEditPriorNoticeforPlacementWithdrawal = 91,
  CanCreateParentWithdrawalofConsent = 92,

  CanEditPTTeacherChecklist = 59,
  CanEditPTParentChecklist = 60,
  CanEditTeacherOTChecklist = 61,
  CanEditParentOTChecklist = 62,

  CanViewReports = 278,
  CanAccessOperationalReports = 259,

  //Befit Review
  CanCreateEdBenefitReview = 111,
  CanViewEdBenefitReview = 112,

  CanRequesttoSharePersonallyIdentifiableInformation = 38,
  CanViewPersonallyIdentifiableInformation = 116,

  CanCaseClose = 104,

  CanSendParentRequestforAdditionalAssessments = 39,
  CanEditParentRequestforAdditionalAssessments = 40,
  CanViewParentRequestforAdditionalAssessments = 100,
  CanReviewParentRequestforAdditionalAssessments = 265,
  CanGenerateProgressReport = 270,
  CanLogOutreach = 271,
  CanDeleteDocument = 274,

  CanAssignToAgency = 275,
  CanViewGlobalSearch = 279,

  CanViewAgency = 277,

  CanReviewNursingReferrals = 295,

  CanCreateCompensatoryServices = 292,
  CanViewCompensatoryServices = 293,
  CanEditCompensatoryServices = 294,
  CanCaptureFirstAttend = 114,

  CanViewMessages = 302,
  CanImpersonate = 322,

  //IEP
  IEPEditPresentLevelsofPerformance = 325,
  IEPViewPresentLevelsofPerformance = 326,
  IEPEditSpecialFactors = 327,
  IEPViewSpecialFactors = 328,
  IEPEditMeasurablePostSecondaryGoals = 329,
  IEPViewSpecialMeasurablePostSecondaryGoals = 330,
  IEPEditMeasurableAnnualGoals = 331,
  IEPViewMeasurableAnnualGoals = 332,
  IEPEditProgressReport = 333,
  IEPViewProgressReport = 334,
  IEPEditRecommendedSpecialEducationProgramsServices = 335,
  IEPViewRecommendedSpecialEducationProgramsServices = 336,
  IEPEditTwelveMonthProgramServices = 337,
  IEPViewTwelveMonthProgramServices = 338,
  IEPEditTestingAccommodations = 339,
  IEPViewTestingAccommodations = 340,
  IEPEditTransitionActivities = 341,
  IEPViewTransitionActivities = 342,
  IEPEditParticipationinStateDistrictWideAssessments = 343,
  IEPViewParticipationinStateDistrictWideAssessments = 344,
  IEPEditParticipationwStudentswithoutDisabilities = 345,
  IEPViewParticipationwStudentswithoutDisabilities = 346,
  IEPEditSpecialTransportationPlacementRecommendation = 347,
  IEPViewSpecialTransportationPlacementRecommendation = 348,
  IEPEditSummaryPage = 349,
  IEPViewSummaryPage = 350,
  IEPEditAttendancePage = 351,
  IEPViewAttendancePage = 352,
  IEPEditAligningGoalsandPrograms = 353,
  IEPViewAligningGoalsandPrograms = 354,
  IEPEditBehaviorInterventionPlan = 355,
  IEPViewBehaviorInterventionPlan = 356,
  IEPEditSpecificLearningDisabilityJustificationForm = 357,
  IEPViewSpecificLearningDisabilityJustificationForm = 358,
  IEPEditEmotionalDisabilityJustificationForm = 359,
  IEPViewEmotionalDisabilityJustificationForm = 360,
  CreateOSHPhysicianReviewTransportationAccommodations = 361,
  EditOSHPhysicianReviewTransportationAccommodations = 362,
  ViewOSHPhysicianReviewTransportationAccommodations = 363,
  CreateHomeInstructionReferralForm = 364,
  EditHomeInstructionReferralForm = 365,
  ViewHomeInstructionReferralForm = 366,
  EditChildOutcomesSummaryForm = 367,
  ViewChildOutcomesSummaryForm = 368,
  //IESP
  IESPEditIESPDocument = 369,
  IESPViewIESPDocument = 370,
  IESPEditPresentLevelsofPerformanceandIndividualNeeds = 371,
  IESPViewPresentLevelsofPerformanceandIndividualNeeds = 372,
  IESPEditStudentNeedsRelatingtoSpecialFactors = 373,
  IESPViewStudentNeedsRelatingtoSpecialFactors = 374,
  IESPEditMeasurablePostSecondaryGoals2 = 375,
  IESPViewSpecialMeasurablePostSecondaryGoals2 = 376,
  IESPEditMeasurableAnnualGoals2 = 377,
  IESPViewMeasurableAnnualGoals2 = 378,
  IESPEditMeasurableAnnualGoalsObjectives = 379,
  IESPViewMeasurableAnnualGoalsObjectives = 380,
  IESPEditReportingProgresstoParents = 381,
  IESPViewReportingProgresstoParents = 382,
  IESPEditRecommendedSpecialEducationProgramsandServices = 383,
  IESPViewRecommendedSpecialEducationProgramsandServices = 384,
  IESPEditTestingAccommodations = 385,
  IESPViewTestingAccommodations = 386,
  IESPEditCoordinatedsetofTransitionActivities = 387,
  IESPViewCoordinatedsetofTransitionActivities = 388,
  IESPEditParticipationinStateDistrictWideAssessments2 = 389,
  IESPViewParticipationinStateDistrictWideAssessments2 = 390,
  IESPEditSpecialTransportation = 391,
  IESPViewSpecialTransportation = 392,
  IESPEditPlacementRecommendation = 393,
  IESPViewPlacementRecommendation = 394,
  IESPEditAttendancePage = 395,
  IESPViewAttendancePage = 396,
  IESPEditServicesPlanDocument = 397,
  IESPViewServicesPlanDocument = 398,
  //SP
  SPEditRecommendedSpecialEducationServices = 399,
  SPViewRecommendedSpecialEducationServices = 400,
  SPEditPlacementRecommendation = 401,
  SPViewPlacementRecommendation = 402,
  SPEditPresentLevelsofPerformanceandIndividualNeeds = 403,
  SPViewPresentLevelsofPerformanceandIndividualNeeds = 404,
  SPEditMeasurableAnnualGoals = 405,
  SPViewMeasurableAnnualGoals = 406,
  SPEditReportingProgresstoParents = 407,
  SPViewReportingProgresstoParents = 408,
  SPEditTestingAccommodations = 409,
  SPViewTestingAccommodations = 410,
  SPEditAttendancePage = 411,
  SPViewAttendancePage = 412,
  // Eval Assignment
  SelectRFAinAP =	413	,
  AssignNYCPSEvaluator =	414	,
  AssignContractAgency =	415	,
  AssignAgencyEvaluator =	416	,
  IssueAA =	417	,
  ReviewAAforms =	418	,
  DeclineAssignment =	419	,
  // Privider Assignment
ViewMDEPRACGlobalWaitlist = 462,
ViewWaitlist = 463,
EditAgencyWorkHours = 464,
ViewAgencyWorkHours = 465,
SortBy = 466,
AdvancedFilters = 467,
AssigntoReassign = 468,
AcceptConfirmProposedAutomatedAssignment = 469,
Manuallyassignproviderstomandates = 470,
Scheduleservicesessions = 471,
Rejectproposedautomatedassignments = 472,
Terminateproviderassignmentsformandates = 473,
Reassignassignmentsformandatesfromonelocationprovidertoanother = 474,
ReviewcaseloadtodetermineifthereisNOlocationproviderforUnclaimedMandates = 475,
Assignmandatestolocationproviderwithadditionalcapacity = 476,
Groupmandatesandrequestcontractassistance = 477,
Groupmandatestoselectservicemodel = 478,
Splitmandatesbeforeassigingtolocationprovider = 479,
Retroactivelyassignproviderstomandates = 480,
Assigntemporaryproviderstomandates = 481,
MarkmandatesasNeverServed = 482,
Recombinesplitmandates = 483,
Viewlocationproviderprofile = 484,
Viewlocationproviderschedule = 485,
TransmitAssignReassignmandatestoContractAgency = 486,
Splitmandatesbeforeassigningtothecontractagencies = 487,
ReviewEditbundles = 488,
UnbundlemandatesToSwitchServiceModels = 489,
Findprimarycontractagency = 490,
ReviewBundleMandateAssignmentToCaseloadRequests = 491,
Splitmandateswithincontractagency = 492,
Assignmandatestocontractagencyproviders = 493,
Rejectmandateassignment = 494,
ConfirmassignmenttoDBNdeltachanges = 495,
Initiateoutreachbydeadlineprocess = 496,
Submitresponsestooutreachbydeadlinerequests = 497,
Resubmitoutreachbydeadlinerequests = 498,
Reviewcontractagenciesandawardmandatestoagencies = 499,
Withdrawstransmittalfromcontractagencies = 500,
TerminateContractagencyproviderassignmentsformandates = 501,
ReassignContractagencyproviderassignmentsformandates = 502,
RetroactivelyAssignAgencyProviders = 503,
AssignsTemporaryProviderstoMandates = 504,
RecombinemandatesSplitwithinContractagency = 505,
EnterReasonforDelay = 506,
MarkmandateswithNeverServedReason = 507,
RequestassignmenttoCaseloadtoDWS = 508,
RequestassignmenttoLocationProvider = 509,
ViewAgencyContactInformation = 510,
MoveMandatestoAwaitingSETSSAuthstatus = 511,
IdentifyIndependentProvider = 512,
IssueRSAP4 = 513,
IssueIA = 514,
IssueblankdocumentationRSAP4 = 515,
SelecttheDOEproviderwithConflictofInterestWaiver = 516,
Respondtooutreachbydeadlinerequests = 517,
AwardmandatestoIndependentProviderswhorespondedtooutreachbydeadlinerequests = 518,
ReviewparentandindependentproviderSETSSteacherRSAP4 = 519,
ReviewindependentproviderIA = 520,
RevokeauthorizationforanIndependentproviderRSAP4 = 521,
RevokeauthorizationforanIndependentproviderIA = 522,
RejectsassignmentRSAP4IA = 523,
ReissueRSAP4documentstoadifferentIndProv = 524,
ReissuesIAdocumentswhenaprovidercannotservethemandate = 525,
TerminateindependentproviderassignmentformandatesRSAP4 = 526,
TerminateindependentproviderassignmentformandatesIA = 527,
ReassignmandatesfromindependentprovidertolocationproviderRSAP4 = 528,
ReassignmandatesfromindependentprovidertolocationproviderIA = 529,
ReassignmandatesfromindependentprovidertocontractagencyRSAP4 = 530,
ReassignmandatesfromindependentprovidertocontractagencyIA = 531,
ConfirmDBNdeltachangestocurrentmandateassignments = 532,
RetroactivelyassignRSAP4IAproviderstomandates = 533,
DOEProviderEnterEncounterCurrentRetroactive = 534,
DOEproviderEnterFirstAttendIfdoneseperately = 535,
ContractOutEnterFirstAttendFirstEncounter = 536,
IndependentProviderEnterFirstAttendFirstEncounter = 537,
ApproveEncounterAttendanceRecords = 538
}
